import { select, put, race, take } from "redux-saga/effects";
import { setShouldRequestMonitoring } from "../_BETA/requestSchedule";
import {
  LOAD_MONITORING,
  LOAD_MONITORING_REQUEST_SUCCESS,
  LOAD_MONITORING_REQUEST_FAIL,
} from "./actionTypes";
import { loadMonitoringRequest, updateMonitoring } from "./actionCreators";
import { createSiteGroups, composeOccurrences } from "../insights/utils";

export function* loadMonitoring(): Generator<any, any, any> {
  while (true) {
    try {
      yield take(LOAD_MONITORING);

      const user = yield select((state: Insite.AppState) => state.auth.user);
      const { selectedSites } = yield select(
        (state: Insite.AppState) => state.betaSelections
      );
      const { daysRange } = yield select(
        (state: Insite.AppState) => state.betaSelections
      );
      if (!user.rolesRestriction) {
        throw Error("Unable to authenticate user");
      }

      yield put(
        loadMonitoringRequest({
          token: user.token,
          siteIds: selectedSites,
          daysRange,
        })
      );
      const { success, fail } = yield race({
        success: take(LOAD_MONITORING_REQUEST_SUCCESS),
        fail: take(LOAD_MONITORING_REQUEST_FAIL),
      });

      if (fail) {
        throw Error(`Monitoring request failed: ${fail}`);
      }

      if (success) {
        const { result: raw } = success;
        const { sites, projects } = yield select(
          (state: Insite.AppState) => state.userSites
        );
        const composed = composeOccurrences(
          Object.values(raw.hit),
          sites,
          projects
        );
        const siteGroups = createSiteGroups(composed, sites, projects);
        yield put(setShouldRequestMonitoring(false));
        yield put(
          updateMonitoring({
            siteGroups,
            composed,
          })
        );
      }
    } catch (error) {
      console.log(`Something went wrong attempting to monitoring: ${error}`);
    }
  }
}
